import clsx from 'clsx';

interface TextWithDotIndicatorProps {
  indicator?: 'teal' | 'sage' | 'amber';
  children?: React.ReactNode;
}

export const TextWithDotIndicator = ({
  indicator,
  children,
}: TextWithDotIndicatorProps) => {
  if (children === null || children === undefined) {
    return <div className="text-zinc-600">--</div>;
  }

  return (
    <div className="flex items-center gap-x-1.5">
      {indicator && (
        <div
          className={clsx(
            'size-1.5 rounded-full',
            indicator === 'teal' && 'bg-teal-600',
            indicator === 'sage' && 'bg-sage-700',
            indicator === 'amber' && 'bg-amber-700',
          )}
          aria-hidden="true"
        />
      )}

      {children}
    </div>
  );
};
